import 'src/config/cosmos/baseConfig'

type WithCosmosStylesProps<T> = (props: T) => JSX.Element

const withCosmosStyles = <P = unknown,>(
  Component: WithCosmosStylesProps<P>
): WithCosmosStylesProps<P> => Component

export default withCosmosStyles
